import { Link } from "react-router-dom";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleNewsletter = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setEmail("");
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold">海角千万资源原创</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              专注于海量原创内容资源的聚合平台，为创作者与企业提供高质量、可信赖的正版原创资源。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/image-text" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">图文素材</Link></li>
              <li><Link to="/category/video" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">原创视频</Link></li>
              <li><Link to="/category/creative" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">创意素材</Link></li>
              <li><Link to="/category/template" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">设计模板</Link></li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">联系我们</Link></li>
              <li><a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">服务条款</a></li>
              <li><a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">隐私政策</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">资源速递</h4>
            <p className="text-foreground-400 text-sm mb-3 leading-relaxed">订阅获取最新原创资源推荐和创作技巧干货。</p>
            <form onSubmit={handleNewsletter} className="flex flex-col gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                className="px-3 py-2 rounded-md text-sm bg-foreground-800 text-background-50 placeholder:text-foreground-500 border border-foreground-700 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                required
              />
              <button
                type="submit"
                className="px-3 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap"
              >
                {submitted ? "已订阅 ✓" : "订阅"}
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 海角千万资源原创. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-300 text-sm transition-colors duration-200" aria-label="B站">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}